import React, { useEffect, useState } from "react";
import "../styles/login.css";
import { LoginApi } from "../api";
import { useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import default_img from "../data/username_icon.png";
import default_img1 from "../data/password_icon.png";
import xeno from "../data/Xenohead-red.png";
import logo from "../data/logo.png";
import { useStateContext } from "../contexts/ContextProvider";

const Login = () => {
  const { setNewUserID } = useStateContext();
  const [username, setUsername] = useState("");
  const navigate = useNavigate();
  const [ValError, setValError] = useState([]);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [password, setPassword] = useState("");

  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);

  const onchangePassword = (e) => setPassword(e.target.value);

  const handleLogin = async (event) => {
    event.preventDefault();
    setPasswordVisible(false);
    setValError([]);
    const updatedErrors = [...ValError];
    if (username === "") {
      updatedErrors[0] = "Please enter username!";
      setValError(updatedErrors);
      return;
    }
    updatedErrors[0] = "";
    if (password === "") {
      updatedErrors[1] = "Please enter password!";
      setValError(updatedErrors);
      return;
    }
    updatedErrors[1] = "";
    const response = await LoginApi(username, password);
    if (response.success) {
      setNewUserID(
        response.data.user_id,
        response.data.token,
        response.data.username,
        null,
        10,
        response.data.company_id,
        response.data.permission_ids,
        2023,
        "Xenowulf",
      );
      return navigate("/Part");
    } else {
      updatedErrors[2] = response.message;
      setValError(updatedErrors);
      return console.log("Login Failed");
    }
  };

  useEffect(() => {
    const userDataString = localStorage.getItem("userData");
    if (!userDataString) {
      const userData = {
        user_id: null,
        token: null,
        user_name: null,
        user_profile: null,
        user_store_id: null,
        user_perm_id: [],
        fiscal_year: new Date().getFullYear(),
      };
      localStorage.setItem("userData", JSON.stringify(userData));
      return navigate("/Login");
    }
    const userData1 = JSON.parse(userDataString);
    if (!userData1) return navigate("/Login");
    else if (userData1.user_id) return navigate("/Part");
  }, [navigate]);

  return (
    <div className="bg-main-gray" style={{ height: "100vh", width: "100vw" }}>
      <Container className="g-0" fluid="true" style={{ padding: "10%" }}>
        <Row className="p-0">
          <Col lg={5} className="p-0">
            <form onSubmit={handleLogin}>
              <Card className="align-items-center">
                <div className="m-3" />
                <div style={{ height: "100px", textAlign: "center" }}>
                  <img
                    src={logo}
                    alt="Description"
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "100%",
                      borderradius: "10px",
                    }}
                  />
                </div>
                <label
                  style={{
                    marginTop: "16%",
                    fontSize: "36px",
                    fontWeight: "bold",
                  }}
                >
                  Sign In
                </label>
                <div style={{ paddingLeft: "16%", paddingRight: "16%" }}>
                  <div className="input-container">
                    <div className="form-group" style={{ marginTop: "8%" }}>
                      <div className="input-icon">
                        <img src={default_img} alt="Email Icon" width="30px" />
                      </div>
                      <input
                        className="input-field"
                        type="text"
                        value={username}
                        tabIndex="1"
                        name="name"
                        placeholder="Username"
                        autoFocus
                        style={{
                          width: "100%",
                          height: "60px",
                          fontSize: "22px",
                        }}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </div>
                  </div>
                  {ValError[0] && (
                    <span style={{ color: "red", fontSize: "18px" }}>
                      {ValError[0]}
                    </span>
                  )}
                </div>

                <div style={{ paddingLeft: "16%", paddingRight: "16%" }}>
                  <div className="input-container">
                    <div className="form-group" style={{ marginTop: "8%" }}>
                      <div className="input-icon">
                        <img
                          src={default_img1}
                          alt="Password Icon"
                          width="30px"
                        ></img>
                      </div>
                      <input
                        className="input-field"
                        type={passwordVisible ? "text" : "password"}
                        name="name"
                        value={password}
                        tabIndex="2"
                        placeholder="Password"
                        style={{
                          width: "100%",
                          height: "60px",
                          fontSize: "22px",
                        }}
                        onChange={onchangePassword}
                      />
                      <button
                        className="password-toggle-button"
                        type="button"
                        onClick={togglePasswordVisibility}
                        style={{
                          position: "absolute",
                          right: "6%",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                        }}
                      >
                        {passwordVisible ? (
                          <div style={{ fontSize: "22px" }}>
                            <FaEye />
                          </div>
                        ) : (
                          <div style={{ fontSize: "22px" }}>
                            <FaEyeSlash />
                          </div>
                        )}
                      </button>
                    </div>
                  </div>
                  {ValError[1] && (
                    <span style={{ color: "red", fontSize: "18px" }}>
                      {ValError[1]}
                    </span>
                  )}
                  {/* <div
                    style={{
                      paddingLeft: "50%",
                      marginTop: "6%",
                      fontSize: "16px",
                      color: "#FF7A33",
                    }}
                  >
                    Forget Password?
                  </div> */}
                </div>
                <div style={{ marginTop: "4%" }}>
                  {ValError[2] && (
                    <span style={{ color: "red", fontSize: "18px" }}>
                      {ValError[2]}
                    </span>
                  )}
                </div>

                <div
                  style={{
                    paddingTop: "20%",
                    paddingLeft: "20%",
                    paddingRight: "20%",
                    marginBottom: "12%",
                  }}
                >
                  <button
                    style={{
                      padding: "12px",
                      backgroundColor: "#d02030",
                      color: "#fff",
                      border: "none",
                      borderRadius: "10px",
                      fontSize: "24px",
                      fontWeight: "bold",
                      width: "160px",
                      height: "60px",
                    }}
                    tabIndex="3"
                    color="white"
                    text="Login"
                    type="submit"
                  >
                    Log In
                  </button>
                </div>
              </Card>
            </form>
          </Col>
          <Col className="d-none d-lg-block" sm={true} style={{ padding: "0" }}>
            <div className="w-100 h-100">
              <img
                className="rounded-xl w-100 h-100"
                src={xeno}
                alt="Description"
                style={{
                  objectFit: "contain",
                  borderradius: "10px",
                  backgroundColor: "#212121",
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
